module.exports = __webpack_public_path__ + "static/media/Inter-Medium.83a6408c.woff";